/**
 * IntelliGems A/B Test — Men/Women size dropdowns in Sticky ATC
 *
 * Control (A): data-sticky-atc-gender="false"
 * Variant (B): data-sticky-atc-gender="true"
 *
 * IntelliGems:
 *   document.body.setAttribute('data-sticky-atc-gender', 'true');
 *
 * Dev: ?sticky_atc_gender_test=b
 */
(function () {
  'use strict';

  if (window.__stickyAtcGenderABTestInit) return;
  window.__stickyAtcGenderABTestInit = true;

  var BODY_ATTR = 'data-sticky-atc-gender';
  var ROOT_ATTR = 'data-sticky-atc-gender-root';
  var WRAP_ATTR = 'data-sticky-atc-gender-wrap';
  var WRAP_CLASS = 'sticky-atc-gender-controls';
  var PICKER_SEL =
    'secondary-variant-select, secondary-variant-select-separate, [class*="sticky-atc__picker"]';
  var OUR_UI_SEL =
    '.sticky-atc-gender-ab__field, .sticky-atc-gender-ab__desktop, .sticky-atc-gender-ab__mobile, .sticky-atc-gender-ab__select-wrap, .sticky-atc-gender-ab__swatch';
  var SIZE_MATCH =
    /US(?:\s*(?:Men|Women))?\s*\d+(?:\.\d+)?|UK(?:\s*(?:Men|Women))?\s*\d+(?:\.\d+)?|US\s*Men\s*\d+(?:\.\d+)?\s*-\s*(?:US\s*)?Women\s*\d+(?:\.\d+)?/i;

  var MEN_TO_WOMEN = {
    'US 4': 'US 6',
    'US 4.5': 'US 6.5',
    'US 5': 'US 7',
    'US 5.5': 'US 7.5',
    'US 6': 'US 8',
    'US 6.5': 'US 8.5',
    'US 7': 'US 9',
    'US 7.5': 'US 9.5',
    'US 8': 'US 10',
    'US 8.5': 'US 10.5',
    'US 9': 'US 11',
    'US 9.5': 'US 11.5',
    'US 10': 'US 12',
    'US 10.5': 'US 12.5',
    'US 11': 'US 13',
    'US 11.5': 'US 13.5',
    'US 12': 'US 14',
    'US 12.5': 'US 14.5',
    'US 13': 'US 15',
    'US 13.5': 'US 15.5',
    'US 14': 'US 16',
    'US 14.5': 'US 16.5',
    'US 15': 'US 17',
  };

  var TAG_ICON =
    '<svg class="sticky-atc-gender-ab__tag" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M2.5 2.5h6.2L14 7.8a1.2 1.2 0 0 1 0 1.7l-4.5 4.5a1.2 1.2 0 0 1-1.7 0L2.5 8.7V2.5zm3.1 4.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"/></svg>';

  var activeGender = 'men';
  var debounceTimer = null;
  var applying = false;
  var syncing = false;

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes' || n === 'b';
  }

  function isDevVariantB() {
    try {
      return (
        new URLSearchParams(window.location.search).get('sticky_atc_gender_test') ===
        'b'
      );
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    return !!(document.body && isTruthy(document.body.getAttribute(BODY_ATTR)));
  }

  function applyDev() {
    if (!isDevVariantB() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(BODY_ATTR))) {
      document.body.setAttribute(BODY_ATTR, 'true');
    }
  }

  function stickySupportsGender() {
    var sticky = document.querySelector('sticky-atc');
    if (!sticky) return false;
    var options = sticky.querySelectorAll('select option');
    var hits = 0;
    for (var i = 0; i < options.length; i++) {
      var text = (options[i].value || options[i].textContent || '').trim();
      if (SIZE_MATCH.test(text)) hits += 1;
      if (hits >= 2) return true;
    }
    return hits > 0;
  }

  function sizeNumber(text) {
    var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*$/);
    return match ? match[1] : '';
  }

  function formatNum(num) {
    return num % 1 === 0 ? String(num) : num.toFixed(1);
  }

  function normSizeKey(text) {
    var v = String(text || '').trim();
    var dual = v.match(
      /^US\s*Men\s*(\d+(?:\.\d+)?)\s*-\s*(?:US\s*)?Women\s*(\d+(?:\.\d+)?)$/i
    );
    if (dual) return 'US ' + dual[1];
    var us = v.match(/US(?:\s*(?:Men|Women))?\s*(\d+(?:\.\d+)?)/i);
    if (us) return 'US ' + us[1];
    var n = v.match(/(\d+(?:\.\d+)?)$/);
    return n ? 'US ' + n[1] : v;
  }

  function regionalPrefix() {
    var regional = window.ComfofeetRegionalSizes;
    if (regional && regional.active && regional.prefix) return regional.prefix;
    return 'US';
  }

  function formatStickySize(sizeText, gender) {
    var usKey = normSizeKey(sizeText);
    var mapped = gender === 'women' ? MEN_TO_WOMEN[usKey] || usKey : usKey;
    var prefix = regionalPrefix();
    var n = parseFloat(sizeNumber(mapped));
    if (isNaN(n)) return sizeText;

    if (prefix === 'UK' || prefix === 'AU') {
      n = gender === 'women' ? n - 2 : n - 1;
      return prefix + ' ' + formatNum(n);
    }

    return prefix + ' ' + formatNum(n);
  }

  function parseCombinedLabel(text) {
    var value = String(text || '').trim();
    var parts = value.split(/\s*\/\s*/);
    if (parts.length < 2) return { color: '', size: value };
    var sizePart = parts[parts.length - 1].trim();
    if (!SIZE_MATCH.test(sizePart) && !/\d/.test(sizePart)) {
      return { color: value, size: '' };
    }
    return {
      color: parts.slice(0, -1).join(' / ').trim(),
      size: sizePart,
    };
  }

  function unique(list) {
    var seen = {};
    var out = [];
    list.forEach(function (item) {
      if (!item || seen[item]) return;
      seen[item] = true;
      out.push(item);
    });
    return out;
  }

  function caretSvg() {
    return '<svg class="icon icon-caret" aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z"/></svg>';
  }

  function parseMoneyToCents(text) {
    var raw = String(text || '').replace(/[^\d.,]/g, '');
    if (!raw) return 0;
    if (raw.indexOf(',') > -1 && raw.indexOf('.') > -1) {
      if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else {
        raw = raw.replace(/,/g, '');
      }
    } else if (/,\d{2}$/.test(raw)) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }
    var num = parseFloat(raw);
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  function formatSavedAmount(templateText, cents) {
    var source = String(templateText || '');
    var formatted = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withSymbol = source.replace(/[\d.,]+/, formatted);
    if (withSymbol === source || !/[^\d.,\s]/.test(source)) {
      var symbol = (source.match(/[^\d.,\s]+/) || ['$'])[0];
      withSymbol = symbol + formatted;
    }
    return withSymbol;
  }

  function enhanceSavingsBadge(sticky) {
    var priceRoot = sticky.querySelector('.sticky-atc__price');
    if (!priceRoot) return;

    var saleEl = priceRoot.querySelector('.price-item--sale, .price__regular .price-item--regular');
    var compareEl = priceRoot.querySelector(
      '.price__compare-price .price-item--regular, .price__compare-price s'
    );
    var badge = priceRoot.querySelector('.price__badge-sale');
    if (!saleEl || !compareEl || !badge) return;

    var saleCents = parseMoneyToCents(saleEl.textContent);
    var compareCents = parseMoneyToCents(compareEl.textContent);
    if (!saleCents || compareCents <= saleCents) return;

    var saved = formatSavedAmount(compareEl.textContent, compareCents - saleCents);
    var html = TAG_ICON + '<span class="nowrap">YOU SAVE ' + saved + '</span>';
    if (badge.innerHTML !== html) badge.innerHTML = html;
  }

  function getConverterGender() {
    var api = window.ComfoFeetSizeGenderConverter;
    if (api && typeof api.getGender === 'function') {
      return api.getGender() === 'women' ? 'women' : 'men';
    }
    var activeMain = document.querySelector('.custom-gender-tab.active[data-gender]');
    if (activeMain) {
      return activeMain.getAttribute('data-gender') === 'women' ? 'women' : 'men';
    }
    return activeGender;
  }

  function setPdpGender(gender) {
    activeGender = gender === 'women' ? 'women' : 'men';
    var api = window.ComfoFeetSizeGenderConverter;
    if (api && typeof api.setGender === 'function') {
      api.setGender(activeGender);
    }
    document.querySelectorAll('[data-sticky-atc-gender-select]').forEach(function (select) {
      if (select.value !== activeGender) select.value = activeGender;
    });
    document.querySelectorAll('[data-sticky-atc-mobile-size]').forEach(refreshMobileSizeLabels);
    document.querySelectorAll('[data-sticky-atc-gender-wrap], [data-sticky-atc-split="1"]').forEach(
      function (wrap) {
        refreshSizeLabels(wrap);
      }
    );
  }

  function syncStickySelection(sticky) {
    var picker = sticky && sticky.querySelector(PICKER_SEL);
    if (!picker || picker.getAttribute('data-sticky-atc-split') !== '1') return;
    var original = findOriginalSelect(picker);
    if (!original) return;
    var rows = collectSizeRows(original);
    var next = currentSelection(original, rows);
    if (!next || !next.size) return;

    picker.querySelectorAll('[data-sticky-atc-gender-size]').forEach(function (sel) {
      if (sel.value !== next.size) sel.value = next.size;
    });
    var mobileSize = picker.querySelector('[data-sticky-atc-mobile-size]');
    if (mobileSize) {
      if (mobileSize.value !== next.size) mobileSize.value = next.size;
      refreshMobileSizeLabels(mobileSize);
    }
    var colorSelect = picker.querySelector('[data-sticky-atc-color]');
    if (colorSelect && next.color && colorSelect.value !== next.color) {
      colorSelect.value = next.color;
    }
  }

  function buildField(labelText, selectClass, ariaLabel) {
    var field = document.createElement('div');
    field.className = 'sticky-atc-gender-ab__field';

    var label = document.createElement('span');
    label.className = 'sticky-atc-gender-ab__label';
    label.textContent = labelText;

    var box = document.createElement('div');
    box.className = 'select sticky-atc-gender-ab__select-wrap';

    var select = document.createElement('select');
    select.className = 'select__select ' + selectClass;
    select.setAttribute('aria-label', ariaLabel);

    box.appendChild(select);
    box.insertAdjacentHTML('beforeend', caretSvg());
    field.appendChild(label);
    field.appendChild(box);
    return { field: field, select: select };
  }

  function findOriginalSelect(picker) {
    var selects = picker.querySelectorAll(
      'select.sticky-atc__variant-select, select.variant-dropdown, select.select__select'
    );
    var fallback = null;
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.closest('.sticky-atc-gender-ab__field')) continue;
      if (!fallback) fallback = select;
      if (isCombinedSelect(select)) return select;
      if (collectSizeRows(select).length >= 2) return select;
    }
    return fallback;
  }

  function isCombinedSelect(select) {
    if (!select || select.options.length < 2) return false;
    var sample = select.options[Math.min(1, select.options.length - 1)];
    var parsed = parseCombinedLabel(sample.value || sample.textContent);
    return !!(parsed.color && parsed.size);
  }

  function collectSizeRows(select) {
    var rows = [];
    Array.prototype.forEach.call(select.options, function (option) {
      // Prefer option.value — gender converter rewrites textContent for display.
      var source = option.value || option.textContent || '';
      if (isCombinedSelect(select)) {
        var parsed = parseCombinedLabel(source);
        if (!parsed.size) return;
        rows.push({
          value: option.value,
          color: parsed.color,
          size: parsed.size,
          disabled: option.disabled,
        });
      } else if (SIZE_MATCH.test(source)) {
        rows.push({
          value: option.value,
          color: '',
          size: option.value || option.textContent,
          disabled: option.disabled,
        });
      }
    });
    return rows;
  }

  function parseVariantJson(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function sizedSrc(src) {
    if (!src) return '';
    var url = String(src);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$180');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=80';
  }

  function imageForColor(variants, color) {
    var needle = String(color || '').trim().toLowerCase();
    if (!needle) return '';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [v.option1, v.option2, v.option3];
      var matches = opts.some(function (opt) {
        return String(opt || '').trim().toLowerCase() === needle;
      });
      if (!matches) continue;
      var src =
        (v.featured_image && (v.featured_image.src || v.featured_image)) ||
        (v.featured_media &&
          v.featured_media.preview_image &&
          v.featured_media.preview_image.src) ||
        (v.image && (v.image.src || v.image)) ||
        '';
      if (src) return sizedSrc(src);
    }
    return '';
  }

  function collectColors(rows) {
    return unique(
      rows
        .map(function (row) {
          return row.color;
        })
        .filter(Boolean)
    );
  }

  function hideOriginalFields(picker, select) {
    var input = select.closest('.product-form__input');
    if (input) input.classList.add('sticky-atc-gender-ab__original');
    picker.querySelectorAll('.product-form__input').forEach(function (field) {
      if (field.contains(select)) return;
      if (field.classList.contains('sticky-atc-gender-ab__field')) return;
      field.classList.add('sticky-atc-gender-ab__original');
    });
  }

  function buildLabeledSelect(gender, sizes, selectedSize) {
    var field = document.createElement('div');
    field.className = 'sticky-atc-gender-ab__field';
    field.setAttribute('data-sticky-atc-gender-field', gender);

    var label = document.createElement('span');
    label.className = 'sticky-atc-gender-ab__label';
    label.textContent = gender === 'women' ? 'WOMEN' : 'MEN';

    var box = document.createElement('div');
    box.className = 'select sticky-atc-gender-ab__select-wrap';

    var select = document.createElement('select');
    select.className = 'select__select sticky-atc-gender-ab__size';
    select.setAttribute('data-sticky-atc-gender-size', gender);
    select.setAttribute('aria-label', gender === 'women' ? 'Women size' : 'Men size');

    sizes.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = formatStickySize(size, gender);
      if (size === selectedSize) option.selected = true;
      select.appendChild(option);
    });

    box.appendChild(select);
    box.insertAdjacentHTML('beforeend', caretSvg());
    field.appendChild(label);
    field.appendChild(box);
    return { field: field, select: select };
  }

  function currentSelection(select, rows) {
    var selected = select.options[select.selectedIndex];
    if (!selected) return rows[0];
    // Prefer value — gender converter rewrites option textContent for display.
    var source = selected.value || selected.textContent || '';
    if (isCombinedSelect(select)) {
      return parseCombinedLabel(source);
    }
    return { color: '', size: selected.value || selected.textContent };
  }

  function findMatch(rows, color, size) {
    var sizeKey = normSizeKey(size);
    return (
      rows.find(function (row) {
        if (color && row.color !== color) return false;
        if (row.disabled) return false;
        if (row.size === size) return true;
        return !!(sizeKey && normSizeKey(row.size) === sizeKey);
      }) ||
      rows.find(function (row) {
        return (!color || row.color === color) && !row.disabled;
      }) ||
      rows[0]
    );
  }

  function refreshSizeLabels(wrap) {
    wrap.querySelectorAll('[data-sticky-atc-gender-size]').forEach(function (sel) {
      var gender = sel.getAttribute('data-sticky-atc-gender-size');
      Array.prototype.forEach.call(sel.options, function (option) {
        option.textContent = formatStickySize(option.value, gender);
      });
    });
  }

  function refreshMobileSizeLabels(select) {
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      option.textContent = formatStickySize(option.value, activeGender);
    });
  }

  function bindDualSizePickers(picker) {
    if (!picker) return false;
    if (picker.getAttribute('data-sticky-atc-split') === '1') {
      if (picker.querySelector('.sticky-atc-gender-ab__mobile')) return false;
      picker.removeAttribute('data-sticky-atc-split');
      picker
        .querySelectorAll(
          '.sticky-atc-gender-ab__desktop, .sticky-atc-gender-ab__mobile, .sticky-atc-gender-ab__field'
        )
        .forEach(function (el) {
          el.remove();
        });
    }

    var original = findOriginalSelect(picker);
    if (!original) return false;

    var rows = collectSizeRows(original);
    var sizes = unique(rows.map(function (row) { return row.size; }));
    if (sizes.length < 2) return false;

    var colors = collectColors(rows);
    var hasColorPicker = colors.length >= 2;
    var variants = parseVariantJson(picker);
    var stickyEl = picker.closest('sticky-atc');

    picker.setAttribute('data-sticky-atc-split', '1');
    hideOriginalFields(picker, original);
    activeGender = getConverterGender();

    var current = currentSelection(original, rows);
    var menField = buildLabeledSelect('men', sizes, current.size);
    var womenField = buildLabeledSelect('women', sizes, current.size);

    var desktop = document.createElement('div');
    desktop.className = 'sticky-atc-gender-ab__desktop';
    desktop.appendChild(menField.field);
    desktop.appendChild(womenField.field);

    var genderField = buildField('Gender', 'sticky-atc-gender-ab__control', 'Select gender');
    genderField.field.classList.add('sticky-atc-gender-ab__field--gender');
    genderField.select.setAttribute('data-sticky-atc-gender-select', 'true');
    genderField.select.innerHTML =
      '<option value="men">Men</option><option value="women">Women</option>';
    genderField.select.value = activeGender;

    var colorField = null;
    var colorSwatch = null;
    if (hasColorPicker) {
      colorField = buildField('Color', 'sticky-atc-gender-ab__control sticky-atc-gender-ab__color', 'Select color');
      colorField.field.classList.add('sticky-atc-gender-ab__field--color');
      colorField.select.setAttribute('data-sticky-atc-color', 'true');
      colors.forEach(function (color) {
        var option = document.createElement('option');
        option.value = color;
        option.textContent = color;
        if (color === current.color) option.selected = true;
        colorField.select.appendChild(option);
      });
      colorSwatch = document.createElement('img');
      colorSwatch.className = 'sticky-atc-gender-ab__swatch';
      colorSwatch.alt = '';
      colorField.select.parentNode.insertBefore(colorSwatch, colorField.select);
    }

    var sizeField = buildField('Size', 'sticky-atc-gender-ab__control', 'Select size');
    sizeField.field.classList.add('sticky-atc-gender-ab__field--size');
    sizeField.select.setAttribute('data-sticky-atc-mobile-size', 'true');
    sizes.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = formatStickySize(size, activeGender);
      if (size === current.size) option.selected = true;
      sizeField.select.appendChild(option);
    });

    var mobile = document.createElement('div');
    mobile.className = 'sticky-atc-gender-ab__mobile';
    mobile.appendChild(genderField.field);
    if (colorField) mobile.appendChild(colorField.field);
    mobile.appendChild(sizeField.field);

    if (stickyEl) {
      stickyEl.classList.toggle('sticky-atc-gender-ab--triple', hasColorPicker);
    }

    function updateColorSwatch(color) {
      if (!colorSwatch) return;
      var src = imageForColor(variants, color);
      if (src) {
        colorSwatch.src = src;
        colorSwatch.hidden = false;
      } else {
        colorSwatch.removeAttribute('src');
        colorSwatch.hidden = true;
      }
    }

    function syncDesktopFromOriginal() {
      var next = currentSelection(original, rows);
      if (!next || !next.size) return;
      var wasSyncing = syncing;
      syncing = true;
      try {
        menField.select.value = next.size;
        womenField.select.value = next.size;
        sizeField.select.value = next.size;
        if (colorField && next.color) {
          colorField.select.value = next.color;
          updateColorSwatch(next.color);
        }
      } finally {
        syncing = wasSyncing;
      }
    }

    function applyFrom(sourceGender, sizeValue, colorValue) {
      if (syncing) return;
      syncing = true;
      try {
        var color =
          colorValue ||
          (colorField && colorField.select.value) ||
          currentSelection(original, rows).color;
        var match = findMatch(rows, color, sizeValue);
        if (!match) return;

        menField.select.value = match.size;
        womenField.select.value = match.size;
        sizeField.select.value = match.size;
        if (colorField && match.color) {
          colorField.select.value = match.color;
          updateColorSwatch(match.color);
        }
        // Only flip PDP gender when shopper uses a gender-specific control —
        // never as a side-effect of quantity-break / original select sync.
        setPdpGender(sourceGender);
        refreshMobileSizeLabels(sizeField.select);

        if (original.value !== match.value) {
          original.value = match.value;
          original.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally {
        syncing = false;
      }
    }

    menField.select.addEventListener('change', function () {
      if (syncing) return;
      applyFrom('men', menField.select.value);
    });
    womenField.select.addEventListener('change', function () {
      if (syncing) return;
      applyFrom('women', womenField.select.value);
    });

    genderField.select.addEventListener('change', function () {
      if (syncing) return;
      var nextGender = genderField.select.value === 'women' ? 'women' : 'men';
      activeGender = nextGender;
      setPdpGender(nextGender);
      refreshMobileSizeLabels(sizeField.select);
      refreshSizeLabels(picker);
    });

    if (colorField) {
      colorField.select.addEventListener('change', function () {
        if (syncing) return;
        applyFrom(activeGender, sizeField.select.value, colorField.select.value);
      });
    }

    sizeField.select.addEventListener('change', function () {
      if (syncing) return;
      applyFrom(activeGender, sizeField.select.value);
    });

    original.addEventListener('change', function () {
      if (syncing) return;
      syncDesktopFromOriginal();
      refreshMobileSizeLabels(sizeField.select);
    });

    picker.appendChild(desktop);
    picker.appendChild(mobile);
    refreshSizeLabels(picker);
    refreshMobileSizeLabels(sizeField.select);
    if (current.color) updateColorSwatch(current.color);
    return true;
  }

  function findInsertTarget(sticky) {
    var left = sticky.querySelector('.sticky-atc__left');
    if (!left) return null;

    var picker = left.querySelector(PICKER_SEL);
    if (picker) return { parent: picker.parentNode, picker: picker };

    return { parent: left, picker: null };
  }

  function isOurUiNode(node) {
    if (!node || node.nodeType !== 1) return true;
    return !!(node.closest && node.closest(OUR_UI_SEL));
  }

  function isHealthyInjection(sticky) {
    var wrap = sticky.querySelector('[' + WRAP_ATTR + ']');
    var picker = sticky.querySelector(PICKER_SEL);
    return !!(
      wrap &&
      picker &&
      (wrap.contains(picker) || picker.contains(wrap)) &&
      picker.querySelector('.sticky-atc-gender-ab__mobile')
    );
  }

  function repairBrokenInjection(sticky) {
    var wrap = sticky.querySelector('[' + WRAP_ATTR + ']');
    var picker = sticky.querySelector(PICKER_SEL);
    if (picker) {
      picker.removeAttribute('data-sticky-atc-split');
      picker
        .querySelectorAll(
          '.sticky-atc-gender-ab__desktop, .sticky-atc-gender-ab__mobile, .sticky-atc-gender-ab__field'
        )
        .forEach(function (el) {
          el.remove();
        });
      picker.querySelectorAll('.sticky-atc-gender-ab__original').forEach(function (el) {
        el.classList.remove('sticky-atc-gender-ab__original');
      });
    }
    if (wrap) {
      var parent = wrap.parentNode;
      if (parent) {
        while (wrap.firstChild) {
          var child = wrap.firstChild;
          if (child.matches && child.matches(OUR_UI_SEL)) {
            wrap.removeChild(child);
            continue;
          }
          parent.insertBefore(child, wrap);
        }
      }
      wrap.remove();
    }
    sticky.classList.remove('sticky-atc-gender-ab--triple');
  }

  function injectIntoSticky(sticky) {
    if (!sticky) return false;
    if (!stickySupportsGender()) return false;

    if (isHealthyInjection(sticky)) {
      var healthyPicker = sticky.querySelector(PICKER_SEL);
      var healthyOriginal = healthyPicker && findOriginalSelect(healthyPicker);
      if (healthyPicker && healthyOriginal) hideOriginalFields(healthyPicker, healthyOriginal);
      enhanceSavingsBadge(sticky);
      return false;
    }

    repairBrokenInjection(sticky);

    var target = findInsertTarget(sticky);
    if (!target || !target.parent) return false;

    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    wrap.setAttribute(WRAP_ATTR, 'true');
    wrap.setAttribute(ROOT_ATTR, 'true');

    if (target.picker) {
      target.parent.insertBefore(wrap, target.picker);
      wrap.appendChild(target.picker);
      bindDualSizePickers(target.picker);
    } else {
      target.parent.appendChild(wrap);
    }

    enhanceSavingsBadge(sticky);
    return true;
  }

  function removeTabs() {
    document.querySelectorAll('[' + WRAP_ATTR + ']').forEach(function (wrap) {
      var parent = wrap.parentNode;
      if (!parent) {
        wrap.remove();
        return;
      }

      while (wrap.firstChild) {
        var child = wrap.firstChild;
        if (child.querySelectorAll) {
          child.querySelectorAll(
            '.sticky-atc-gender-ab__field, .sticky-atc-gender-ab__desktop, .sticky-atc-gender-ab__mobile'
          ).forEach(function (el) {
            el.remove();
          });
          child.removeAttribute('data-sticky-atc-split');
          child.querySelectorAll('.sticky-atc-gender-ab__original').forEach(function (el) {
            el.classList.remove('sticky-atc-gender-ab__original');
          });
        }
        parent.insertBefore(child, wrap);
      }
      wrap.remove();
    });

    document.querySelectorAll('sticky-atc.sticky-atc-gender-ab--triple').forEach(function (el) {
      el.classList.remove('sticky-atc-gender-ab--triple');
    });

    document.querySelectorAll('[' + ROOT_ATTR + ']').forEach(function (el) {
      if (!el.getAttribute(WRAP_ATTR)) el.remove();
    });
  }

  function apply() {
    if (applying) return;
    applying = true;

    try {
      applyDev();
      var variantB = isVariantB();
      document.documentElement.classList.toggle('sticky-atc-gender-b', variantB);

      if (!variantB) {
        removeTabs();
        return;
      }

      if (!window.location.pathname || window.location.pathname.indexOf('/products/') === -1) {
        return;
      }

      document.querySelectorAll('sticky-atc').forEach(function (sticky) {
        injectIntoSticky(sticky);
        enhanceSavingsBadge(sticky);
      });
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(apply, 120);
  }

  function bindMainTabSync() {
    document.addEventListener(
      'click',
      function (event) {
        if (!isVariantB()) return;
        var mainTab = event.target.closest('.custom-gender-tab[data-gender]');
        if (!mainTab) return;
        setTimeout(function () {
          setPdpGender(mainTab.getAttribute('data-gender'));
          document.querySelectorAll('[data-sticky-atc-mobile-size]').forEach(refreshMobileSizeLabels);
        }, 0);
      },
      true
    );

    document.addEventListener('variant:change', function () {
      if (!isVariantB()) return;
      document.querySelectorAll('sticky-atc').forEach(function (sticky) {
        if (isHealthyInjection(sticky)) {
          syncStickySelection(sticky);
          enhanceSavingsBadge(sticky);
        } else {
          scheduleApply();
        }
      });
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!isVariantB()) return;
        if (
          event.target.closest(
            '.custom-gender-tab, .ig-variant-pills__btn, .quantity-break, [data-quantity-break], .swatch'
          )
        ) {
          setTimeout(function () {
            document.querySelectorAll('sticky-atc').forEach(syncStickySelection);
          }, 50);
        }
      },
      true
    );
  }

  function boot() {
    apply();
    bindMainTabSync();

    if (document.body && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        if (applying || syncing) return;
        var shouldApply = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && m.attributeName === BODY_ATTR) {
            shouldApply = true;
            break;
          }
          if (m.type !== 'childList') continue;

          var inSticky =
            (m.target && m.target.closest && m.target.closest('sticky-atc')) ||
            (m.target && m.target.matches && m.target.matches('sticky-atc'));
          if (!inSticky) {
            var nodes = m.addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              var node = nodes[j];
              if (!node || node.nodeType !== 1) continue;
              if (node.matches && (node.matches('sticky-atc') || node.querySelector('sticky-atc'))) {
                shouldApply = true;
                break;
              }
            }
            if (shouldApply) break;
            continue;
          }

          var changed = [];
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            changed.push(n);
          });
          Array.prototype.forEach.call(m.removedNodes, function (n) {
            changed.push(n);
          });
          for (var k = 0; k < changed.length; k++) {
            if (!isOurUiNode(changed[k])) {
              shouldApply = true;
              break;
            }
          }
          if (shouldApply) break;
        }
        if (shouldApply) scheduleApply();
      }).observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR],
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener('shopify:section:load', scheduleApply);
    [300, 800, 1600].forEach(function (delay) {
      window.setTimeout(scheduleApply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ComfofeetStickyAtcGender = {
    apply: apply,
    isVariantB: isVariantB,
  };
})();
